/**
 * Client-side analytics config. All values are PUBLIC by design: these
 * tokens are embedded in the browser bundle and visible to any user.
 *
 * Each integration is optional — if the env var is unset, the provider
 * silently no-ops so the app still works without analytics configured.
 */

export const analyticsConfig = {
  posthog: {
    key: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    /**
     * Route events through our own domain via a Next.js rewrite
     * (see next.config.mjs). This avoids ad blockers that blanket-block
     * posthog.com hostnames. The rewrite forwards to the real PostHog
     * ingestion endpoint server-side.
     */
    apiHost: "/ingest",
    /**
     * The UI host is used for session-replay playback links etc. It stays
     * on the real PostHog domain.
     */
    uiHost: "https://us.posthog.com",
  },
  metaPixel: {
    id: process.env.NEXT_PUBLIC_META_PIXEL_ID,
  },
} as const;
